import Vue from 'vue'
import Router from 'vue-router'
import CreateTicket from '@/pages/CreateTicket'
import Search from '@/pages/Search'
import Vips from '@/pages/Vips'
import CreateVip from '@/pages/CreateVip'
import Recharge from '@/pages/Recharge'
import VipView from '@/pages/VipView'
import Ticket from '@/pages/Ticket'
import Login from '@/pages/Login'
import AccountRecord from '@/pages/AccountRecord'
import NavApp from '@/pages/NavApp'
import NotFound from '@/pages/404'
import Payment from '@/pages/Payment'
import Readme from '@/pages/Readme'
import Versions from '@/pages/Versions'
import RecentTickets from '@/pages/RecentTickets'
import ViewIndexBrand from '@/pages/ViewIndexBrand'
import ViewIndexColors from '@/pages/ViewIndexColors'
import ViewIndexFlaws from '@/pages/ViewIndexFlaws'
import ViewIndexPrices from '@/pages/ViewIndexPrices'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: NavApp,
      children: [
        {
          path: '/create-ticket',
          name: 'CreateTicket',
          component: CreateTicket
        },
        {
          path: '/search',
          name: 'Search',
          component: Search
        },
        {
          path: '/vips',
          name: 'Vipse',
          component: Vips
        },
        {
          path: '/create-vip',
          name: 'CreateVip',
          component: CreateVip
        },
        {
          path: '/recharge/:phone',
          name: 'Recharge',
          component: Recharge
        },
        {
          path: '/account-records/:idView',
          name: 'AccountRechargeRecord',
          component: Recharge
        },
        {
          path: '/vip/:phone',
          name: 'VipView',
          component: VipView
        },
        {
          path: '/ticket/:ticket',
          name: 'Ticket',
          component: Ticket
        },
        {
          path: '/vip-account-record/:id',
          name: 'AccountRecord',
          component: AccountRecord
        },
        {
          path: '/404',
          name: 'NotFound',
          component: NotFound
        },
        {
          path: '/pay/:type/:idView',
          name: 'Pay',
          component: Payment
        },
        {
          path: '/readme',
          name: 'Readme',
          component: Readme
        },
        {
          path: '/versions',
          name: 'Verions',
          component: Versions
        },
        {
          path: '/tickets',
          name: 'Tickets',
          component: RecentTickets
        },
        {
          path: '/order-brands',
          name: 'OrderBrand',
          component: ViewIndexBrand
        },
        {
          path: '/order-colors',
          name: 'OrderColor',
          component: ViewIndexColors
        },
        {
          path: '/order-flaws',
          name: 'OrderFlaw',
          component: ViewIndexFlaws
        },
        {
          path: '/order-prices',
          name: 'OrderPrice',
          component: ViewIndexPrices
        },
        {
          path: '/',
          redirect: '/search'
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js